const workNestPalette = {
  primary: "#12054d",
    secondary: "#21a17e"
};

export { workNestPalette };

  